import { render, staticRenderFns } from "./SavedItem.vue?vue&type=template&id=61b17083&"
import script from "./SavedItem.vue?vue&type=script&lang=js&"
export * from "./SavedItem.vue?vue&type=script&lang=js&"
import style0 from "./SavedItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports